export const ImagesConfig = {
  default: {
    url: 'https://cdn2.qaroni.com/workards/images/login_illustration.svg',
    alt: 'Ilutración por defecto',
  },
  workards: {
    url_white: 'https://cdn2.qaroni.com/workards/logos/workards-logo-white.svg',
    url_black: 'https://cdn2.qaroni.com/workards/logos/workards-logo-black.svg',
    alt: 'Workards by Qaroni',
  },
  signup: {
    url: 'https://cdn2.qaroni.com/workards/images/sign_up_illustration.svg',
    alt: 'Ilustración crear cuenta',
  },
  forgot: {
    url: 'https://cdn2.qaroni.com/workards/images/forgot_illustration.svg',
    alt: 'Ilustración olvidé contraseña',
  },
  login: {
    url: 'https://cdn2.qaroni.com/workards/images/login_illustration.svg',
    alt: 'Ilustración login',
  },
  company: {
    url: 'https://cdn2.qaroni.com/workards/images/dafault-company-image.png',
    alt: 'Default Company Logo',
  },
  createCompany: {
    url: 'https://cdn2.qaroni.com/workards/images/create_company.svg',
    alt: 'Create company',
  },
  invitationNotification: {
    url: 'https://cdn2.qaroni.com/workards/images/invitation_notification.svg',

    alt: 'Invitation notification',
  },
  spinner: {
    url: 'https://cdn2.qaroni.com/workards/logos/workards-logo-black.svg',
    alt: 'Spinner logo',
  },
  maleAvatar: {
    url: 'https://cdn2.qaroni.com/workards/images/male_avatar_illustration.svg',
    alt: 'Male avatar',
  },
  femaleAvatar: {
    url: 'https://cdn2.qaroni.com/workards/images/female_avatar_illustration.svg',
    alt: 'Female avatar',
  },
  version: {
    url: 'https://cdn2.qaroni.com/workards/images/version_control_illustration.svg',
    alt: 'Version illustration',
  },
  companyProfile: {
    url: 'assets/img/profile_icon_8.svg',
    alt: 'Company profile',
  },
  timeManagement: {
    url: 'assets/img/default-time-management.svg',
    alt: 'Time management',
  },
  shiftsIcon: {
    url: 'assets/img/shift_icon.svg',
    alt: 'Shifts icon',
  },
  evaluationsIcon: {
    url: 'assets/img/evaluations_icon.svg',
    alt: 'Evaluations icon',
  },
  appStore: {
    url: 'assets/img/app-store.svg',
    alt: 'App Store',
  },
  playStore: {
    url: 'assets/img/play-store.svg',
    alt: 'Play Store',
  },
  contract: {
    url: 'assets/img/contract.svg',
    alt: 'Contract',
  },
  emptyContract: {
    url: 'assets/img/empty_contract.svg',
    alt: 'Empty contract',
  },
  emptySchedules: {
    url: 'assets/img/empty-schedules.svg',
    alt: 'Empty Schedule',
  },
  emptyResult: {
    url: 'assets/img/empty-result.svg',
    alt: 'Empty result',
  },
  emptyTask: {
    url: 'assets/img/empty-tasks.svg',
    alt: 'Empty tasks',
  },
  emptyEmployee: {
    url: 'assets/img/empty-employees.svg',
    alt: 'Empty Employees',
  },
  emptyAbsences: {
    url: 'assets/img/empty-absences.svg',
    alt: 'Empty Absences',
  },
  emptyImputation: {
    url: 'assets/img/empty-imputation-tasks.svg',
    alt: 'Empty Imputation',
  },
  emptyProjects: {
    url: 'assets/img/empty-projects.svg',
    alt: 'Empty Projects',
  },
  emptyScheduleDefault: {
    url: 'assets/img/empty-calendar.svg',
    alt: 'Empty Schedule Default',
  },
  emptyReports: {
    url: 'assets/img/empty-reports.svg',
    alt: 'Empty Reports',
  },
};
